import type { SubTemplateProps } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'

export function PresentationSlideTemplate({ sub, display, controls, slots }: SubTemplateProps) {
  return (
    <>
      <div className={`md-subs-presentation-row relative mx-auto mb-10 aspect-video w-[calc(100%-96px)] max-h-[640px] max-w-5xl overflow-hidden rounded-lg bg-[#f8f9fb] p-10 shadow-[0_20px_50px_rgba(0,0,0,0.28)]${display.isChecked ? ' md-subs-presentation-row--checked ring-4 ring-[#4f8cff]' : ''}`}>
        <div className="md-subs-presentation-number absolute right-6 top-5 text-sm font-semibold text-[#98a1b2]">{sub.subNumber || display.elId}</div>
        <div className="md-subs-presentation-title max-w-[80%] text-4xl font-semibold leading-tight text-[#111827] [&_.md-sub-title-link]:text-[#111827]">{controls.content.title}</div>
        <div className="md-subs-presentation-text mt-8 max-w-[78%] text-xl leading-[1.45] text-[#374151] [&_.md-sub-text]:whitespace-normal [&_.md-sub-text]:text-[#374151]">{controls.content.text}</div>
        <div className="md-subs-presentation-foot absolute inset-x-10 bottom-8 flex items-center justify-between border-t border-[#d8dee9] pt-4 text-sm text-[#6b7280]">
          <span>{controls.content.time}</span>
          <span className="flex items-center gap-3">{controls.links.answers}{controls.links.submsges}{controls.actions.check}{controls.actions.favorite}{controls.actions.quickReply}</span>
        </div>
      </div>
      {slots.allChildren}
    </>
  )
}
